<template>
    <div class="ui-search-results">
        <div class="ui-search-results__title">
            <span>Результаты поиска</span>

            <span class="ui-search-results__count">{{ count }}</span>
        </div>

        <div v-if="isVisibleSort" class="ui-search-results__controls">
            <UIResultSelect
                v-model="selectedSort"
                :options="sortOptions"
                label="Сортировать:"
                @update:model-value="$emit('update:sort', $event)"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { defineEmits, defineProps, PropType, ref } from 'vue';

    import { SortOption } from '@/types/form.type.ts';

    import UIResultSelect from '@/components/ui/UIResultSelect/UIResultSelect.vue';

    const props = defineProps({
        count: {
            type: Number,
            default: 0,
        },
        initialSort: {
            type: String,
            default: 'date_asc',
        },
        sortOptions: {
            type: Array as PropType<SortOption[]>,
            default: () => [
                { label: 'по дате окончания (1-9)', value: 'date_asc' },
                { label: 'по дате начала (9-1)', value: 'date_desc' },
                { label: 'по цене (возрастание)', value: 'price_asc' },
                { label: 'по цене (убывание)', value: 'price_desc' },
            ],
        },
        isVisibleSort: {
            type: Boolean,
            default: true,
        },
    });

    defineEmits<{
        (e: 'update:sort', value: string): void,
    }>();

    const selectedSort = ref(props.initialSort);
</script>

<style lang="scss" scoped>
    @use './UISearchResults.scss' as *;
</style>
